import { inject } from 'vue'

function injectStrict<T>(key: string, fallback?: T) {
	const resolved = inject(key, fallback)
	if (resolved === undefined) {
		throw new Error(`Could not resolve ${key}`)
	}

	return resolved
}

export default injectStrict
